module.exports = __webpack_public_path__ + "static/img/headbackground.848e963.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rightsDetails/Daoan/headbackground.png
// module id = B0k5
// module chunks = 59